import * as React from "react";

import { useDatasources } from "@/shared/state/visualization/hooks";

import { useEphemeralWorkspaceState } from "../WorkspaceCtx/hooks";

/**
 * Derives unique dataset IDs relevant to this workspace.
 *
 * Datasource datasets (what the workspace was opened for) appear first,
 * followed by any additional datasets discovered from loaded workspace files.
 */
export function useActiveDatasetIds(): string[] {
  const datasources = useDatasources();
  const { files } = useEphemeralWorkspaceState();

  return React.useMemo(() => {
    const ids = new Set<string>();

    for (const ds of datasources) {
      if (ds.type === "dataset") {
        ids.add(ds.value.datasetId);
      }
    }

    for (const file of files) {
      if (file.association_id) {
        ids.add(file.association_id);
      }
    }

    return Array.from(ids);
  }, [datasources, files]);
}
